import React, { useState, useCallback } from "react";
import useBirthdayPhoto from "../../Hooks/usePhotoList";
import { Container } from "../Greetings/Greetings.styled";
import { FaCamera } from "react-icons/fa";
import {
  Wrapper,
  GalleryContainer,
  GalleryItem as StyledGalleryItem,
  ModalOverlay,
  ModalImage,
} from "./Photos.styled";

const Photos = () => {
  const { data, loading, error } = useBirthdayPhoto();
  const [selectedImage, setSelectedImage] = useState(null);

  const openModal = useCallback((url) => setSelectedImage(url), []);
  const closeModal = useCallback(() => setSelectedImage(null), []);

  if (loading) return <p>Loading...</p>;
  if (error || !data) return <p>Error: {JSON.stringify(error)}</p>;

  const birthdayPhotos = data.birthdayPhotos;

  return (
    <Wrapper>
      <Container>
        <div className="heading">
          <FaCamera />
          <h1>Photos</h1>
        </div>
        <GalleryContainer>
          {birthdayPhotos.map((photo) => (
            <MemoizedGalleryItem
              key={photo.id}
              photo={photo}
              openModal={openModal}
            />
          ))}
        </GalleryContainer>

        {selectedImage && (
          <ModalOverlay onClick={closeModal}>
            <ModalImage src={selectedImage} alt="Modal Image" />
          </ModalOverlay>
        )}
      </Container>
    </Wrapper>
  );
};

const GalleryItem = ({ photo, openModal }) => (
  <StyledGalleryItem
    onClick={() => openModal(photo?.image?.url ?? "/default-profile.png")}
  >
    <img
      src={photo?.image?.url ?? "/default-profile.png"}
      alt={photo?.description ?? "Birthday"}
      loading="lazy"
    />
  </StyledGalleryItem>
);

const MemoizedGalleryItem = React.memo(GalleryItem);

export default Photos;
